export default "__VITE_ASSET__DSAO9XLq__"